export default "__VITE_ASSET__C_8TU0pT__"